<template>
  <div class="chat-scroll base-scroller" ref="scroll" @scroll="onScroll">
    <div class="scroll-body" ref="scrollBody">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    allowScrollTop: Boolean, // 是否禁用scrollTop触发
    isFixedScrollBottom: Boolean, // 是否固定在底部
  },
  data() {
    return {
      triggerScrollBottom: false, // 是否触发了滚动到底部，这个时候，不触发onScroll
    };
  },
  computed: {
    innerIsFixedScrollBottom: {
      get() {
        return this.isFixedScrollBottom;
      },
      set(value) {
        this.$emit('update:isFixedScrollBottom', value);
      },
    },
  },
  created() {},
  mounted() {
    this.observerScrollHeight();
  },

  methods: {
    onScroll() {
      if (this.triggerScrollBottom) {
        this.triggerScrollBottom = false;
        return;
      }
      const el = this.$refs.scroll;
      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        // 滚动条接近底部（这里设置了一个 5 像素的误差范围，可以根据实际情况调整）
        this.innerIsFixedScrollBottom = true;
      } else {
        this.innerIsFixedScrollBottom = false;
      }
      if (scrollTop === 0 && this.allowScrollTop) {
        this.$emit('scroll-top');
      }
    },
    // 加载更多的时候保持滚动条位置
    keepScrollTopByLoadMore() {
      const el = this.$refs.scroll;
      // 滚到最顶部
      const oldScrollHeight = el.scrollHeight;
      const oldScrollTop = el.scrollTop;
      this.$nextTick(() => {
        // 更新成功后，需要保持之前滚动条位置
        const newScrollHeight = el.scrollHeight;
        el.scrollTop = newScrollHeight - oldScrollHeight + oldScrollTop;
      });
    },
    // 滚动到底部
    scrollBottom(isSmooth = false) {
      const bodyHeight = this.$refs.scrollBody.clientHeight;
      const scrollHeight = this.$refs.scroll.clientHeight;
      if (isSmooth) {
        this.$refs.scroll.scrollTo({
          top: bodyHeight - scrollHeight,
          behavior: 'smooth',
        });
      } else {
        this.$refs.scroll.scrollTop = bodyHeight - scrollHeight;

      }
      this.triggerScrollBottom = true;
      this.innerIsFixedScrollBottom = true;
    },
    // 监听高度变化
    observerScrollHeight() {
      const resizeObserverScrollBody = new ResizeObserver(() => {
        if (!this.innerIsFixedScrollBottom) return;
        this.scrollBottom();
      });
      resizeObserverScrollBody.observe(this.$refs.scrollBody);

      const resizeObserverScroll = new ResizeObserver(() => {
        if (!this.innerIsFixedScrollBottom) return;
        this.scrollBottom();
      });
      resizeObserverScroll.observe(this.$refs.scroll);
      this.$once('hook:destroyed', () => {
        resizeObserverScrollBody.disconnect();
        resizeObserverScroll.disconnect();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.chat-scroll{
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/components/chat-scroll.vue